import React from 'react';
import { Calculator, RefreshCw } from 'lucide-react';
import Button from '../../../../../components/ui/Button';

const QuickAdjustmentSidebar = ({ 
  formData, 
  setFormData, 
  calculateConversion 
}) => {
  // Предопределенные наборы конвертации
  const predefinedConversions = [
    { 
      label: '10%', 
      value: '10', 
      fromType: 'percent', 
      toType: 'decimal' 
    },
    { 
      label: '0.5', 
      value: '0.5', 
      fromType: 'decimal', 
      toType: 'percent' 
    },
    { 
      label: '1/4', 
      value: '1/4', 
      fromType: 'fraction', 
      toType: 'percent' 
    },
    { 
      label: '50%', 
      value: '50', 
      fromType: 'percent', 
      toType: 'decimal' 
    }
  ];

  // Обработчик быстрой конвертации
  const handleQuickConversion = (conversion) => {
    setFormData({
      value: conversion.value,
      fromType: conversion.fromType,
      toType: conversion.toType
    });
    calculateConversion();
  };

  return (
    <div className="bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 p-5 shadow-sm">
      <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-4 flex items-center">
        <Calculator className="w-5 h-5 mr-2 text-green-500" />
        Быстрая конвертация
      </h3>
      
      <div className="space-y-3 mb-4">
        {predefinedConversions.map((conversion, index) => (
          <Button
            key={index}
            variant="outline"
            fullWidth
            onClick={() => handleQuickConversion(conversion)}
            className="justify-between"
          >
            <span>{conversion.label}</span>
            <span className="text-xs text-gray-500">
              {conversion.fromType} → {conversion.toType}
            </span>
          </Button>
        ))}
      </div>

      {/* Описание быстрой конвертации */}
      <div className="bg-green-50 dark:bg-green-900/20 p-3 rounded-lg border border-green-100 dark:border-green-800">
        <h4 className="text-sm font-medium text-green-700 dark:text-green-300 mb-2">
          Как использовать
        </h4>
        <p className="text-xs text-green-600 dark:text-green-400">
          Нажмите на любую из кнопок, чтобы быстро конвертировать 
          распространенные процентные значения между различными типами представления.
        </p>
      </div>
    </div>
  );
};

export default QuickAdjustmentSidebar;